class AnimationRule {
    name;
    keyframes;
    css;
    native;
    constructor(name, keyframes, css){
        this.name = name;
        this.keyframes = keyframes;
        this.css = css;
    }
    get key() {
        return this.name;
    }
    get text() {
        return `@keyframes ${this.name}{` + Object.entries(this.keyframes).reduce((acc, [key, variables])=>{
            const variableText = Object.entries(variables).map(([name, value])=>`${name}:${value}`).join(';');
            return acc + `${key}{${variableText}}`;
        }, '') + '}';
    }
}

export { AnimationRule as default };
